import { DocumentDetails_DocumentFragment } from '@/modules/documents/graphql/DocumentDetails.generated';
import {
  CreateEntityDocumentRelationshipInput,
  DeleteEntityDocumentRelationshipInput,
  EntityDocumentRelationshipRelationshipType,
} from '@/types/schema';
import { getNodes } from '@/utils/graphqlUtils';

export function getAssociatedEntityDocumentRelationshipInputs({
  householdId,
  documentId,
  entityIds,
  testamentaryEntityIds,
  initialDocument,
}: {
  householdId: string;
  documentId: string;
  entityIds: string[];
  testamentaryEntityIds: string[];
  initialDocument?: DocumentDetails_DocumentFragment;
}): {
  createInputs: CreateEntityDocumentRelationshipInput[];
  deleteInputs: DeleteEntityDocumentRelationshipInput[];
} {
  const createInputs: CreateEntityDocumentRelationshipInput[] = [
    ...entityIds.map((entityID) => ({
      householdID: householdId,
      documentID: documentId,
      entityID,
      relationshipType: EntityDocumentRelationshipRelationshipType.Mentioned,
    })),
    ...testamentaryEntityIds.map((testamentaryEntityID) => ({
      householdID: householdId,
      documentID: documentId,
      testamentaryEntityID,
      relationshipType: EntityDocumentRelationshipRelationshipType.Mentioned,
    })),
  ];

  if (!initialDocument) {
    return { createInputs, deleteInputs: [] };
  }

  const initialEntityIds = new Set<string>();
  const initialTestamentaryEntityIds = new Set<string>();

  getNodes(initialDocument.entityDocumentRelationships).forEach(
    ({ entity, testamentaryEntity }) => {
      if (entity) {
        initialEntityIds.add(entity.id);
      } else if (testamentaryEntity) {
        initialTestamentaryEntityIds.add(testamentaryEntity.id);
      }
    }
  );

  const deleteInputs: DeleteEntityDocumentRelationshipInput[] = [
    ...Array.from(initialEntityIds)
      .filter((id) => !entityIds.includes(id))
      .map((entityID) => ({ documentID: documentId, entityID })),
    ...Array.from(initialTestamentaryEntityIds)
      .filter((id) => !testamentaryEntityIds.includes(id))
      .map((testamentaryEntityID) => ({
        documentID: documentId,
        testamentaryEntityID,
      })),
  ];

  return { createInputs, deleteInputs };
}
